import React, { useState } from "react"
import { FormTextField } from "../../../generic/GenericTextFields"
import { Box, Button, CircularProgress, Stack } from "@mui/material"
import { useFormik } from "formik";
import { object, string } from "yup";
import { AlreadyHaveAccount } from "../generic/GenericDialogFooter";
import { LOGIN_FORMS } from "../../../../enums/loginFormEnums";
import { rendResetPassword } from "../../../../config/apisauce";

export const ForgotPasswordForm = ({ handleNextForm, handleOpenLoginDialog }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSend = async (values) => {
    setIsLoading(true);
    const response = await rendResetPassword(values);
    if (response.ok) {
      handleNextForm(LOGIN_FORMS[2]);
    }
    setIsLoading(false);
  };

  const formik = useFormik({
    initialValues: {},
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: object().shape({
      'email': string().email('Invalid email format').required('Email is required'),
    }),
    enableReinitialize: true,
    onSubmit: (values) => handleSend(values),
  });

  return (
    <Stack gap={4}>
      <FormTextField
        value={formik.values.email}
        placeholder={'example@email.com'}
        label={'Email'}
        error={Boolean(formik?.errors?.email)}
        helperText={formik?.errors?.email}
        handleChange={(value) => formik.setFieldValue('email', value)}
      />
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button variant="contained" sx={{ color: '#FFF', width: { xs: '100%', sm: '250px' } }} onClick={() => formik.handleSubmit()} endIcon={isLoading && <CircularProgress size={14} color="inherit" />} disabled={isLoading}>Send</Button>
      </Box>
      <AlreadyHaveAccount handleOpenLoginDialog={handleOpenLoginDialog}/>
    </Stack>
  )
}